import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiGet, apiPatch } from "../../lib/api-client";
import { useAuthStore } from "../../stores/authStore";

interface ProfileUser {
  email: string;
  name: string;
  role: "user" | "admin";
  customName: boolean;
}

interface ProfileResponse {
  user: ProfileUser;
}

export function useProfile() {
  return useQuery({
    queryKey: ["profile"],
    queryFn: () => apiGet<ProfileResponse>("/users/me"),
  });
}

export function useUpdateProfile() {
  const queryClient = useQueryClient();
  const updateUser = useAuthStore((s) => s.updateUser);

  return useMutation({
    mutationFn: (data: { name: string }) =>
      apiPatch<ProfileResponse>("/users/me", data),
    onSuccess: (data) => {
      updateUser({ name: data.user.name });
      queryClient.invalidateQueries({ queryKey: ["profile"] });
    },
  });
}
